/**
 * Detect hardware tier for model recommendations.
 */

export type HardwareTier = 'low' | 'mid' | 'high';

export type HardwareInfo = {
  tier: HardwareTier;
  hasWebGPU: boolean;
  hasFp16: boolean;
  deviceMemoryGb: number | null;
  cores: number;
  isMobile: boolean;
  label: string;
};

function getWin(): any {
  const g: any = typeof global !== 'undefined' ? global : {};
  return g.window || g;
}

export async function detectHardware(): Promise<HardwareInfo> {
  const win = getWin();
  const nav = win.navigator || {};
  const ua = String(nav.userAgent || '').toLowerCase();
  const isMobile = /android|iphone|ipad|ipod|mobile|opera mini|iemobile/.test(ua);
  const cores = typeof nav.hardwareConcurrency === 'number' ? nav.hardwareConcurrency : 2;
  const deviceMemoryGb =
    typeof nav.deviceMemory === 'number' ? nav.deviceMemory : null;

  let hasWebGPU = false;
  let hasFp16 = false;
  let largeBuffer = false;

  try {
    if (nav.gpu && typeof nav.gpu.requestAdapter === 'function') {
      const adapter = await nav.gpu.requestAdapter();
      if (adapter) {
        hasWebGPU = true;
        if (adapter.features && typeof adapter.features.has === 'function') {
          hasFp16 = adapter.features.has('shader-f16');
        }
        if (adapter.limits && adapter.limits.maxStorageBufferBindingSize) {
          largeBuffer = adapter.limits.maxStorageBufferBindingSize >= 2147483648;
        }
      }
    }
  } catch {
    hasWebGPU = false;
  }

  let tier: HardwareTier = 'low';
  if (hasWebGPU && !isMobile && (hasFp16 || largeBuffer || (deviceMemoryGb != null && deviceMemoryGb >= 8))) {
    tier = 'high';
  } else if (!isMobile && (hasWebGPU || cores >= 4 || (deviceMemoryGb != null && deviceMemoryGb >= 4))) {
    tier = 'mid';
  } else {
    tier = 'low';
  }

  let label = 'Máy yếu / di động';
  if (tier === 'mid') label = 'Máy vừa';
  if (tier === 'high') label = 'Máy mạnh (WebGPU)';

  return {
    tier,
    hasWebGPU,
    hasFp16,
    deviceMemoryGb,
    cores,
    isMobile,
    label,
  };
}

export function tierRank(t: HardwareTier): number {
  if (t === 'high') return 3;
  if (t === 'mid') return 2;
  return 1;
}
